import React from "react";
import { Header } from "../header";

export const LobbyScreen = (props) =>
{
    return(
    <div id="game">
    <Header/>
<div className ="divtext"><b>{props.prName}</b></div>
<img src = {props.PColors != undefined ? "https://cyberbox.trgu.ru/public/avatars/lobby/PlayerMain" + (props.PColors + 1) +".png": "Аватар загружается\n" }></img><React.Fragment><br/></React.Fragment>
<div className ="divtext"><b>{props.GlobalGamepoints}</b> очков</div>    
    </div>
    );
}